export const AVIARY_COORDS = { lat: 14.6706566, lng: 121.0119919 };
export const AVIARY_DIRECTIONS_URL = "https://maps.app.goo.gl/gZDvucy6mAoDLjEe8";
const MAP_EMBED_SRC = `https://maps.google.com/maps?q=${AVIARY_COORDS.lat},${AVIARY_COORDS.lng}&z=16&output=embed`;

interface LocationMapProps {
  height?: string;
  className?: string;
}

const LocationMap = ({ height = "420px", className = "" }: LocationMapProps) => (
  <iframe
    title="Mysher Aviary location on Google Maps"
    src={MAP_EMBED_SRC}
    style={{ border: 0, width: "100%", height }}
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    className={`rounded-2xl ${className}`}
  />
);

export default LocationMap;
